import { escapeAttribute, escapeHtml, getElement } from "./dom";
import { input } from "./formControls";
import { getOdooModelUrl } from "./odooUrls";
export function renderExtraction(extraction, onCreatePartners) {
    getElement("extraction").innerHTML = `
    <article class="group">
      <h2>Extracted Details</h2>
      <p class="summary">Confidence: ${Math.round(extraction.confidence * 100)}%</p>
      ${renderNotes(extraction.notes)}
      <form id="create-partner-form" class="form">
        <label class="checkbox"><input type="checkbox" name="createCompany" checked /> Create company</label>
        ${input("Company name", "company.name", extraction.company.name)}
        ${input("Company email", "company.email", extraction.company.email)}
        ${input("Phone", "company.phone", extraction.company.phone)}
        ${input("Website", "company.website", extraction.company.website)}
        ${input("Street", "company.street", extraction.company.street)}
        ${input("ZIP", "company.zip", extraction.company.zip)}
        ${input("City", "company.city", extraction.company.city)}
        ${input("VAT", "company.vat", extraction.company.vat)}

        <label class="checkbox"><input type="checkbox" name="createContact" checked /> Create contact</label>
        ${input("Existing parent company ID", "parentCompanyId", undefined, "number")}
        ${input("Contact name", "contact.name", extraction.contact.name)}
        ${input("Contact email", "contact.email", extraction.contact.email)}
        ${input("Job title", "contact.function", extraction.contact.function)}
        ${input("Contact phone", "contact.phone", extraction.contact.phone)}
        ${input("Mobile", "contact.mobile", extraction.contact.mobile)}

        <button id="create-button" type="submit">Create Odoo contact / company</button>
      </form>
    </article>
  `;
    getElement("create-partner-form").addEventListener("submit", (event) => {
        event.preventDefault();
        onCreatePartners();
    });
}
export function renderCreateSuccess(result, request) {
    const company = request.company;
    const contact = request.contact;
    const companySummary = result.companyId && company?.name
        ? `<p><strong>${escapeHtml(company.name)}</strong>${company.email ? ` - ${escapeHtml(company.email)}` : ""}</p>`
        : "";
    const contactSummary = result.contactId && contact?.name
        ? `<p><strong>${escapeHtml(contact.name)}</strong>${contact.email ? ` - ${escapeHtml(contact.email)}` : ""}</p>`
        : "";
    const links = [
        result.companyId
            ? `<a href="${escapeAttribute(getOdooModelUrl("res.partner", result.companyId))}" target="_blank" rel="noreferrer">Open company #${result.companyId}</a>`
            : "",
        result.contactId
            ? `<a href="${escapeAttribute(getOdooModelUrl("res.partner", result.contactId))}" target="_blank" rel="noreferrer">Open contact #${result.contactId}</a>`
            : ""
    ]
        .filter(Boolean)
        .map((link) => `<li>${link}</li>`)
        .join("");
    getElement("extraction").innerHTML = `
    <article class="group success-card">
      <h2>Created in Odoo</h2>
      <p>The reviewed company/contact data was created successfully.</p>
      ${companySummary}
      ${contactSummary}
      ${links ? `<ul>${links}</ul>` : ""}
    </article>
  `;
}
function renderNotes(notes) {
    if (notes.length === 0) {
        return "";
    }
    return `<ul class="notes">${notes.map((note) => `<li>${escapeHtml(note)}</li>`).join("")}</ul>`;
}
